import { Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { Button, Checkbox } from '@fourthwall/components';
import { SCOPE_GROUPS } from './ScopesTab.consts';
import * as S from './ScopesTab.styled';
import { useUpdatePlatformAppClientScopes } from './hooks/useUpdatePlatformAppClientScopes';
const validationSchema = Yup.object().shape({
    scopes: Yup.array().min(1, 'At least one scope must be selected'),
});
const getInitialValues = (app) => ({
    scopes: app?.scopes || [],
});
export const ScopesTab = ({ app }) => {
    const { updatePlatformAppClientScopes, isLoading } = useUpdatePlatformAppClientScopes();
    const handleScopesSave = (scopes) => {
        if (!app.id)
            return;
        updatePlatformAppClientScopes([{ clientId: app.id }, { scopes }]);
    };
    const handleSubmit = (values) => {
        handleScopesSave(values.scopes);
    };
    return (React.createElement(Formik, { initialValues: getInitialValues(app), validationSchema: validationSchema, onSubmit: handleSubmit }, ({ submitForm, values, setFieldValue }) => {
        const currentScopes = values.scopes || [];
        const isScopeSelected = (scopeValue) => {
            return currentScopes.includes(scopeValue);
        };
        const toggleScope = (scopeValue, checked) => {
            const scope = scopeValue;
            if (checked) {
                setFieldValue('scopes', [...currentScopes, scope]);
            }
            else {
                setFieldValue('scopes', currentScopes.filter((s) => s !== scope));
            }
        };
        return (React.createElement(Form, null,
            React.createElement(S.Container, null,
                React.createElement(S.Description, null, "Select the permissions your app needs to function properly. Only request the scopes that are necessary for your app's functionality."),
                React.createElement(S.GridContainer, null, SCOPE_GROUPS.map((group) => (React.createElement(S.GroupContainer, { key: group.header },
                    React.createElement(S.GroupHeader, null,
                        React.createElement(S.GroupTitle, null, group.header),
                        group.description && (React.createElement(S.GroupDescription, null, group.description))),
                    React.createElement(S.TypesContainer, null,
                        React.createElement(S.ReadWriteContainer, null, group.scopes.map((scope) => (React.createElement(S.ReadWritePair, { key: scope.value },
                            React.createElement(Checkbox, { value: isScopeSelected(scope.value) || false, onValueChange: (v) => toggleScope(scope.value, v), size: "small" }),
                            React.createElement(S.ReadWriteLabel, null, scope.label)))))))))),
                React.createElement(S.ButtonContainer, null,
                    React.createElement(Button, { label: "Save Changes", appearance: "primary", onClick: submitForm, disabled: isLoading, loading: isLoading })))));
    }));
};
